import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPublicPageView } from "./ga4";

export function GA4RouteTracker() {
    const { pathname } = useLocation();

    useEffect(() => {
        trackPublicPageView(pathname);
    }, [pathname]);

    return null;
}